import React from "react";
import styled from "styled-components";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import LinkButton from "@common/LifeAtButton/Variants/LinkButton";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import LifeAtLogo from "@resources/logos/LifeAt-Logo-Large.svg";
import { buildRoute } from "@util/RouteUtil";
import { BrowserUtil } from "@util/index";
import StripeSubscriptionPortalButton from "../../features/user/components/UserAccountModal/AccountModalComponents/StripeSubscriptionPortalButton";

const Page = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    height: 30vh;
    width: 100%;
    margin: 50px 0;
`;

const Logo = styled(LifeAtLogo)`
    fill: black;
`;

const SubHeader = styled.div`
    padding: 10px 0;
    width: 30%;
    margin-bottom: 20px;
    text-align: center;
`;

const StyledSubBtn = styled(StripeSubscriptionPortalButton)`
    width: 200px;
    margin: 30px;
`;

const StyledLinkButton = styled(LinkButton)`
    margin: 5px 30px;
`;

const SUBHEADER_LABEL =
    "We have gathered all of your account information, please hit continue to see your subscription details";
function ManageSubscriptionPage() {
    const { userData }: UserContextType = useUserContext();

    return (
        <Page>
            <Logo />

            <SubHeader>{SUBHEADER_LABEL}</SubHeader>

            {userData?.proUserInfo && (
                <StyledSubBtn isVisible={true} hideLabel={true} overrideButtonText={"Continue"} />
            )}
            <StyledLinkButton
                label={"Return to LifeAt"}
                handleClick={() => BrowserUtil.openPage(buildRoute(Routes.App), false)}
            />
        </Page>
    );
}

export default ManageSubscriptionPage;
